<template>
  <div id="app">
    <log-menu-header />
    <router-view />
    <!-- <el-row
      ><el-col
        ><div class="footer-img">
          <img src="@/assets/SVG/logo.svg" alt="Login Farma" />

          <h3 style="font-size: 16px">LOG-IN FARMA S.R.L © - {{ new Date().getFullYear() }}</h3>
        </div></el-col
      ></el-row
    > -->
  </div>
</template>

<script>
import LogMenuHeader from './components/logMenuHeader.vue'

export default {
  name: 'app',
  components: {
    LogMenuHeader,
  },
}
</script>

<style lang="scss">
@import '@/styles/log-in.scss';
#app {
  width: 100%;
  height: 100%;
}
body {
  padding: 0px !important;
  width: 100%;
}
.grecaptcha-badge {
  display: none !important;
}

.footer-img {
  text-align: center;
  background: $naranja;
  font-weight: 300 !important;
  color: #fff;
  padding: 10px;
  height: 50%;
}
.footer-img h3 {
  font-weight: 300;
  margin: 10px;
  font-size: 22px;
}

.footer-img img {
  display: block;
  height: 60px;
  margin: 0 auto;
  margin-top: 20px;
}
</style>
